// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ed52121","453":"800737fe","455":"b911f207","977":"da6dcaaf"}[chunkId] + ".chunk.js";
};